
import $ from 'jquery';

class Modal {

  openModal(modal){
    if(typeof modal !== 'undefined'){
      this.closeModal();
      modal.modal();
    }
  }

  closeModal(modal = $('.modal')){
    //close all open modals, defaults to all modals
    modal.modal('hide');
  }
}

module.exports = new Modal();
